import template from './auditprogress.html';
import controller from './auditprogress.controller';
import './auditprogress.styl';

let auditprogressComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default auditprogressComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogress/auditprogress.component.js